<app-deprecated-modal-form
    #filterModal
    id="filter-modal"
    [form]="trainingReportFilter"
    label="Apply"
    headerText="reporting.reports.trainingReport.filterResults"
    (save)="onFilter(trainingReportFilter.filters)"
>
    <app-form-training-report-filter #trainingReportFilter></app-form-training-report-filter>
</app-deprecated-modal-form>

<div class="ui basic segment report-page" [class.loading]="isLoading">
    <app-header [title]="'reporting.reports.trainingReport.title' | translate" [back]="true" class="report-header">
        <div class="buttons">
            <ui-button type="outline" (click)="filterModal.show()" style="float: right">Filter</ui-button>
            <ui-button type="primary" style="float: right" [matMenu]="exportMenu">
                Export <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('csv')">{{ 'export-as-csv' | translate }}</button>
                <button mat-menu-item (click)="onExport('xlxs')">{{ 'export-as-xlsx' | translate }}</button>
            </mat-menu>
        </div>
    </app-header>

    <div *ngIf="report && report.data.sheets && report.data.sheets.length; else emptyState" class="report-body">
        <app-report-table
            #reportTable
            [report]="report"
            emptyText="reporting.reports.trainingReport.thereAreNoTrainingProgramsToReportOn"
        ></app-report-table>
    </div>

    <ng-template #emptyState>
        <div class="ui segment">
            <app-empty-state
                label="reporting.reports.trainingReport.thereAreNoTrainingProgramsToReportOn"
            ></app-empty-state>
        </div>
    </ng-template>
</div>
